import { render, staticRenderFns } from "./ProducerAttachedFilesDrawer.vue?vue&type=template&id=54e26524&scoped=true"
import script from "./ProducerAttachedFilesDrawer.vue?vue&type=script&lang=js"
export * from "./ProducerAttachedFilesDrawer.vue?vue&type=script&lang=js"
import style0 from "./ProducerAttachedFilesDrawer.vue?vue&type=style&index=0&id=54e26524&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e26524",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54e26524')) {
      api.createRecord('54e26524', component.options)
    } else {
      api.reload('54e26524', component.options)
    }
    module.hot.accept("./ProducerAttachedFilesDrawer.vue?vue&type=template&id=54e26524&scoped=true", function () {
      api.rerender('54e26524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/producers/ProducerAttachedFilesDrawer.vue"
export default component.exports